import React, {useMemo} from 'react';
import {Box, TableCell, TableRow} from '@mui/material';
import PropTypes from 'prop-types';

const ShimmerTableRow = ({
  columnCount = 7,
  hideSelectAll = false,
  hideCheckbox = false
}) => {
  // This component should mirror the structure used by DataTableHead/DataTableBody.
  // `columnCount` is expected to be the total number of cells in the row, including
  // the leading and trailing 60px cells when they are shown.

  const hasSideCells = useMemo(
    () => !(hideSelectAll && hideCheckbox),
    [hideSelectAll, hideCheckbox]
  );
  const middleCellCount = useMemo(
    () => columnCount - (hasSideCells ? 2 : 0),
    [columnCount, hasSideCells]
  );

  return (
    <TableRow data-testid='shimmer-row'>
      {hasSideCells && (
        <TableCell
          sx={{
            width: '60px'
          }}>
          {!hideCheckbox && (
            <Box
              className='shimmer-content'
              sx={{width: 24, height: 24, borderRadius: '4px'}}
            />
          )}
        </TableCell>
      )}

      {Array.from({length: Math.max(0, middleCellCount)}).map(() => (
        <TableCell className='custom-data-table-cell' key={crypto.randomUUID()}>
          <Box className='shimmer-content' sx={{width: '100%'}} />
        </TableCell>
      ))}

      {hasSideCells && (
        <TableCell
          sx={{
            width: '60px'
          }}
        />
      )}
    </TableRow>
  );
};

ShimmerTableRow.propTypes = {
  columnCount: PropTypes.number.isRequired,
  hideSelectAll: PropTypes.bool,
  hideCheckbox: PropTypes.bool
};

export default React.memo(ShimmerTableRow);
